import { render, staticRenderFns } from "./editBankMember.vue?vue&type=template&id=1ceafd1c&lang=pug"
import script from "./editBankMember.vue?vue&type=script&lang=js"
export * from "./editBankMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports